import { useState, useEffect } from "react";
import "../styles/home.css";
import { useNavigate } from "react-router-dom";
import axios from "../api/axios";
import { notify } from "./toast";
import { HashLink } from "react-router-hash-link";

const Home = () => {

    const [FAQs, setFAQs] = useState([]);
    const [quickActions, setQuickActions] = useState([]);
    const [services, setServices] = useState([]);
    const [activeQuestion, setActiveQuestion] = useState('');
    const [hospitals, setHospitals] = useState([]);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const navigate = useNavigate();

    const bufferToBase64 = (bufferArray) => {
        const chunkSize = 100000;
        let base64String = '';

        for (let i = 0; i < bufferArray.length; i += chunkSize) {
            const chunk = bufferArray.slice(i, i + chunkSize);
            base64String += String.fromCharCode.apply(null, chunk);
        }

        return btoa(base64String);
    }

    const fetchAllHospitals = async () => {
        try {

            const response = await axios.get("/public/getAllHospitals");

            const data = response?.data?.hospitals;
            const imageGeneratedHospitals = data?.map((h) => {
                if (h?.photo)
                    return { ...h, photo: `data:image/jpeg;base64,${bufferToBase64(h?.photo?.data)}` }
                return h
            });

            setHospitals(imageGeneratedHospitals.splice(0, 4));

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        }
    }

    useEffect(() => {
        fetchAllHospitals();
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        setFAQs([
            {
                qn: "What is the Ayush Medical Discount Card?",
                ans: "The Ayush Medical Discount Card is a membership-based card that offers customers reduced prices on prescription and over-the-counter medicines at partner pharmacies and medical stores."
            },
            {
                qn: "How does the discount card work?",
                ans: "Customers simply present their card at any affiliated hospitals to avail discounted rates."
            },
            {
                qn: "Where can the card be used?",
                ans: "The card can be used at any partner hospital or medical store within our network. The list of partnered hospitals and pharmacies will be available on our website/app and updated regularly."
            },
            {
                qn: "What kind of discounts can I expect?",
                ans: "Discounts typically apply to health checkups, medical tests, prescription medications, OTC drugs, and essential healthcare products."
            },
            {
                qn: "Who can apply for the card?",
                ans: "Anyone can apply—students, working professionals, senior citizens, and individuals with chronic health conditions. There are no age or income restrictions."
            },
            {
                qn: "How much does the membership cost?",
                ans: "Membership fees vary depending on the plan chosen. Details of pricing will be provided at the time of registration."
            },
            {
                qn: "How do I register for the discount card?",
                ans: "Users can register online through the mobile app or website."
            },
            {
                qn: "Is the card transferable?",
                ans: "No. Each card is issued to an individual and is non-transferable to ensure accurate tracking and security."
            },
            {
                qn: "What if I lose my card?",
                ans: "You can request a replacement through the app, website, or customer support."
            },
            {
                qn: "How are partner hospitals selected?",
                ans: "We collaborate with trusted hospitals that maintain quality standards, fair pricing, and proper medicine handling practices."
            },
            {
                qn: "Why should I get the Medical Discount Card?",
                ans: "It helps reduce out-of-pocket healthcare expenses, makes essential medicines more affordable, and provides convenient access to a wide network of pharmacies—especially useful for individuals needing long-term or chronic medication."
            },
        ]);

        setQuickActions([
            ["Our Specialities", "/svg/home-specialities.svg"],
            ["Our Locations", "/svg/home-locations.svg"],
            ["Our Doctors", "/svg/home-doctors.svg"],
            ["View Medical Records", "/svg/home-reports.svg"],
            ["Health checkups", "/svg/home-checkup.svg"]
        ]);

        setServices([
            ["Cardiology", "/svg/home-heart.svg"],
            ["Neurology", "/svg/home-brain.svg"],
            ["Oncology", "/svg/home-cancer.svg"],
            ["Gastro", "/svg/home-gastro.svg"],
            ["Mother & Child", "/svg/home-pediatric.svg"]
        ])
    }, []);

    const toggleQuestion = (index) => {
        setActiveQuestion(activeQuestion === index ? null : index);
    };

    const handleContact = async (e) => {
        e.preventDefault();
        try {

            const response = await axios.post("/public/contact", {
                name,
                email,
                message
            });

            notify('success', response?.data?.success);
        } catch (err) {
            notify('failed', err?.response?.data?.message);
        } finally {
            setName('');
            setEmail('');
            setMessage('');
        }
    }

    return (
        <div className="ayush-container">

            <header id="header" className="header">
                <div
                    style={{
                        backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.4)),url("/header.jpg")`,
                    }}
                >
                    <h1>Ayush Care Services</h1>
                </div>
            </header>

            <section className="quick-actions">
                {quickActions.map((item, index) => (
                    <div key={index} className="action-card">
                        <div
                            key={item[0]}
                            style={{
                                width: 50,
                                height: 50,
                                backgroundColor: 'var(--primary-color)',
                                mask: `url(${item[1]}) no-repeat center`,
                                WebkitMask: `url(${item[1]}) no-repeat center`,
                                maskSize: "contain",
                                WebkitMaskSize: "contain",
                            }}
                        />
                        <p>{item[0]}</p>
                    </div>
                ))}
            </section>

            <section id="about" className="about">
                <h2>About us</h2>
                <div className="about-content">
                    <p>
                        Our objective is to provide accessible and affordable healthcare support through the issuance of medical discount cards that enable customers to receive price reductions on prescription and over-the-counter medicines at partner pharmacies. It aims to establish a wide network of affiliated pharmacies and medical stores, ensuring cardholders can conveniently access discounted medications across multiple locations. The initiative also seeks to promote health awareness and encourage responsible medication use by making essential medicines more affordable for all sections of society. Additionally, it plans to offer value-added healthcare services such as periodic health check-up discounts, wellness program tie-ups, or teleconsultation services as part of the card benefits (optional based on future expansion). The system will create a seamless and transparent process for managing customer memberships, pharmacy partnerships, and discount tracking using secure and user-friendly digital platforms. Overall, it strives to contribute to the reduction of out-of-pocket healthcare expenses, especially for individuals with chronic conditions or those requiring long-term medication.
                    </p>
                    <img src="/images/Ayushcare-about.jpg" alt="Ayush Care Services" />
                </div>
            </section>

            <section id="services" className="services">
                <h2> Our Services</h2>
                <div className="specialities">
                    {services.map((sp) => (
                        <div key={sp} className="speciality-card">
                            <div
                                key={sp[0]}
                                style={{
                                    width: 50,
                                    height: 50,
                                    backgroundColor: 'var(--primary-color)',
                                    mask: `url(${sp[1]}) no-repeat center`,
                                    WebkitMask: `url(${sp[1]}) no-repeat center`,
                                    maskSize: "contain",
                                    WebkitMaskSize: "contain",
                                }}
                            />
                            <p>{sp[0]}</p>
                        </div>
                    ))}
                </div>
                <button onClick={() => navigate('/services')}>View all</button>
            </section>

            <section id="locations" className="locations-gallery">
                {hospitals?.length !== 0 &&
                    <>
                        <h2>Our Hospitals</h2>
                        <div className="gallery">
                            {hospitals?.map((hospital) => (
                                <div
                                    key={hospital?._id}
                                    className="gallery-item"
                                    style={{
                                        backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.2)),url(${hospital?.photo})`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                    }}
                                    onClick={() => navigate(`/hospital/${hospital?._id}`)}
                                >
                                    <p>{hospital?.name}</p>
                                </div>
                            ))}
                        </div>
                        <div className="locations-button">
                            <button onClick={() => navigate('/locations')}>See more</button>
                        </div></>
                }
            </section>

            <section className="faq-section">
                <h2>Frequently Asked Questions</h2>
                <div className="faq-items">
                    {FAQs.map((item, index) => (
                        <div className="faq-item" key={index}>
                            <div
                                // @ts-ignore
                                className={`faq-question ${activeQuestion === index ? 'faq-active' : ''}`}
                                onClick={() => toggleQuestion(index)}
                            >
                                {item.qn}
                            </div>
                            {
                                // @ts-ignore
                                activeQuestion === index && (
                                    <div className="faq-answer">
                                        {item.ans}
                                    </div>
                                )}
                        </div>
                    ))}
                </div>
            </section>

            <footer className="footer">
                <div className="footer-content">
                    <div className="footer-left">
                        <h3>Quick Links</h3>
                        <ul>
                            <li><HashLink smooth to="/#header">Home</HashLink></li>
                            <li><HashLink to="/#about">About Us</HashLink></li>
                            <li><HashLink to="/#services">Services</HashLink></li>
                            <li><HashLink to="/#locations">Locations</HashLink></li>
                        </ul>
                    </div>

                    <div id="contact" className="footer-right">
                        <h3>Contact Us</h3>
                        <form>
                            <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your Name" required />
                            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your Email" required />
                            <textarea placeholder="Your Message" value={message} onChange={(e) => setMessage(e.target.value)} rows={3} required></textarea>
                            <button onClick={(e) => handleContact(e)}>Send</button>
                        </form>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>© 2025 Aysuh care services. All Rights Reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Home;